<template>
  <modal :show.sync="showModal" header-classes="justify-content-center" @close="handleClose">
    <h4 slot="header" class="title title-up">
      Remove A Disciple
    </h4>
    <h2 v-if="error" style="color:red;">
      There was an error. Please refresh your page.
    </h2>

    <el-row>
      <label class="col-md-4 col-form-label">Disciple To Remove</label>
      <el-select
        class="col-md-8 select-default"
        filterable
        clearable
        v-model="removedDisciplePersonId"
        placeholder="Select disciple..."
      >
        <el-option
          v-for="item in removableDisciples"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
    </el-row>

    <br>

    <p v-if="validationError === true" style="color: red;">
      A disciple is required.
    </p>
    <br><br>
    <template slot="footer">
      <p-button @click.native="handleClose">
        Cancel
      </p-button>
      <p-button type="danger" v-if="!saving" @click.native="handleSave">
        Remove Disciple
      </p-button>
      <p-button type="danger" v-if="saving">
        Removing...
      </p-button>
          &nbsp;&nbsp;
    </template>
  </modal>
</template>

<script>
import { mapState, mapActions, vuex } from 'vuex';
import Modal from '../UIComponents/Modal';

import { RepositoryFactory } from '../../repositories/repositoryFactory';

const DisciplesRepository = RepositoryFactory.get('disciples');

function validateForm(removedDisciplePersonId) {
    return !!removedDisciplePersonId;
}

export default {
    name: 'RemoveDiscipleModal',
    components: {
        Modal
    },
    data() {
        return {
            showModal: false,
            material: '',
            validationError: false,
            removableDisciples: [],
            removedDisciplePersonId: '',
            endedReason: null,
            discipleOptions: [],
            loading: false,
            error: '',
            saving: false
        };
    },
    computed: {

    },
    methods: {
        disciplesRemoveMethod(query) {
            // console.log(listType);
            if (query !== '') {
                this.loading = true;
                setTimeout(() => {
                    this.loading = false;
                    this.discipleOptions = this.removableDisciples.filter((item) => item.name.toLowerCase()
                        .indexOf(query.toLowerCase()) > -1);
                }, 200);
            } else {
                this.discipleOptions = this.removableDisciples;
            }
        },
        handleSave() {
            this.saving = true;
            if (!validateForm(this.removedDisciplePersonId)) {
                this.validationError = true;
                this.saving = false;
                return;
            }

            DisciplesRepository.endDisciple(this.removedDisciplePersonId, this.endedReason)
            // axios.put(`/disciples/end/${this.removedDisciplePersonId}`,
            //     {
            //         ended_reason: this.endedReason,
            //     },
            //     { headers: { Authorization: this.$store.getters.token } })
                .then((response) => {
                    this.saving = false;
                    this.$emit('discipleChange');
                    this.$message(response.data.message);
                })
                .catch((error) => {
                    this.saving = false;
                    this.$message(error.response.data.message);
                });

            this.$emit('save');
            this.$emit('close');

            this.removedDisciplePersonId = '';
            this.validationError = false;
        },
        handleClose() {
            this.removedDisciplePersonId = '';
            this.validationError = false;
            this.$emit('close');
        },
        getRemovableDisciplesList() {
            DisciplesRepository.getRemovableDisciplesList()
                .then((response) => {
                    this.removableDisciples = response.data.data;
                    this.discipleOptions = this.removableDisciples;
                })
                .catch((error) => {
                    this.error = error;
                });
        },
    },
    props: {
        show: Boolean,
    },
    watch: {
        show(val) {
            this.showModal = val;
            if (this.showModal === true) {
                this.getRemovableDisciplesList();
            }
        }
    },
    created() {
        // this.getRemovableDisciplesList();
    }

};
</script>
